import { DateTime } from 'luxon';

export function buildInitialManualReservationEditData(reservation) {
  return {
    ...reservation,
    deposit_received: Boolean(reservation?.deposit_received),
    deposit_received_date: reservation?.deposit_received_date,
    deposit_platform: reservation?.deposit_platform,
    final_payment_received: Boolean(reservation?.final_payment_received),
    final_payment_date: reservation?.final_payment_date,
    final_payment_platform: reservation?.final_payment_platform,
    final_payment_amount: reservation?.final_payment_amount
  };
}

export function getInitialManualReservationDateInputValue(reservation) {
  if (!reservation?.deposit_received_date) {
    return '';
  }

  const date = new Date(reservation.deposit_received_date);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return date.toISOString().split('T')[0];
}

export function buildManualReservationDepositReceivedDate(dateValue) {
  if (!dateValue) {
    return null;
  }

  const [year, month, day] = dateValue.split('-').map(Number);
  const parisDateTime = DateTime.fromObject(
    { year, month, day, hour: 12, minute: 0 },
    { zone: 'Europe/Paris' }
  );

  return parisDateTime.toISO();
}

export function mergeUpdatedManualReservation(previousReservation, updatedReservation) {
  return {
    ...updatedReservation,
    relatedEvent: previousReservation?.relatedEvent
  };
}

export function getManualReservationRemainingAmount(reservation) {
  const minimum = reservation?.min_price;
  const basePrice = Number(minimum !== '' && minimum != null ? minimum : reservation?.max_price || 0);
  const depositAmount = reservation?.deposit_received ? Number(reservation?.deposit_amount || 0) : 0;

  return basePrice - depositAmount;
}

export function buildFinalPaymentToggleEditData(previousEditData, isReceived) {
  const remainingAmount = Math.max(0, getManualReservationRemainingAmount(previousEditData));

  return {
    ...previousEditData,
    final_payment_received: isReceived,
    final_payment_date:
      isReceived && !previousEditData.final_payment_date
        ? new Date().toISOString().split('T')[0]
        : previousEditData.final_payment_date,
    final_payment_amount:
      isReceived && !previousEditData.final_payment_amount && remainingAmount > 0
        ? remainingAmount.toString()
        : previousEditData.final_payment_amount
  };
}
